"use strict";

exports.__esModule = true;
exports.SlidingInterval = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var createInterval = function createInterval(duration) {
  var endMillis = Date.now();
  var startMillis = endMillis - duration;
  return {
    startMillis: startMillis,
    endMillis: endMillis
  };
};

/**
 * Render prop powered sliding interval.
 * Repeatedly calls the supplied render prop with a sliding interval according to the
 * given duration and frequency.
 */
var SlidingInterval = exports.SlidingInterval = /*#__PURE__*/function (_Component) {
  function SlidingInterval() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      interval: createInterval(_this.props.duration),
      controlledDuration: _this.props.duration,
      controlledFrequency: _this.props.frequency
    };
    _this.tick = function () {
      _this.setState(function () {
        return {
          interval: createInterval(_this.props.duration)
        };
      });
      _this.nextFrame();
    };
    return _this;
  }
  _inheritsLoose(SlidingInterval, _Component);
  var _proto = SlidingInterval.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.nextFrame();
  };
  SlidingInterval.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.controlledDuration !== props.duration || state.controlledFrequency !== props.frequency) {
      return {
        controlledDuration: props.duration,
        controlledFrequency: props.frequency
      };
    }
    return null;
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.controlledDuration !== this.props.duration || this.state.controlledFrequency !== this.props.frequency) {
      this.nextFrame();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  };
  _proto.nextFrame = function nextFrame() {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(this.tick, this.props.frequency);
  };
  _proto.render = function render() {
    var interval = this.state.interval;
    var children = this.props.children;
    return children(interval);
  };
  return SlidingInterval;
}(_react.Component);
SlidingInterval.defaultProps = {
  duration: 60000,
  frequency: 200
};